import { isThemeName, type Theme, type ThemeName, } from "@bracket/ui/types";
import * as library from "./library";

const { VITE_DEFAULT_THEME, } = import.meta.env;
export const DEFAULT_THEME_NAME: ThemeName = (
	isThemeName(VITE_DEFAULT_THEME)
		? VITE_DEFAULT_THEME
		: typeof (globalThis as unknown as { matchMedia: (query: string) => { matches: boolean; }; }).matchMedia === "function"
			? globalThis.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
			: "dark"
);



export const THEMES: Record<string, Theme> = library;
